import {MutationTree} from 'vuex';
import {RootState} from '@/store/type';
import {LoginInfo} from '@/store/auth/auth.types';

export const MainMutation: MutationTree<RootState> = {
    ['MAIN_LOGIN'](state: RootState, payload: LoginInfo): any {
        state.userInfo = payload
    },
    ['_loading'](state: RootState, payload: boolean): any {
        console.log('DEBUG: payload', payload);
        state.loading = payload
    }
};
